import React, { useContext } from "react";

import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react";
import Ecommerce from "../../img/ec.png";
import MusicApp from "../../img/ms.png";
import RealEstate from "../../img/rs.png";
import BookStore from "../../img/bs.png";
import EDA from "../../img/fifaeda.png";
import Birds from "../../img/birds.png";
import "swiper/css";
import { themeContext } from "../../Context";


const Portfolio = () => {

  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;


  return (
    <div className="portfolio">
         <span style={{ color: darkMode ? "white" : "" }}>Recent Projects</span>
      <span>Portfolio</span>

      <Swiper
      spaceBetween={30}
      slidesPerView={3}
      grabCursor={true}
      className="portfolio-slider"
      >
        <SwiperSlide>
          <img src={Ecommerce} alt="ecommerce" />

          <ul className="p"  style={{ listStyleType: "none" }}>
         <a href="https://alphamart.herokuapp.com/">   <li >View Link</li> </a> 
         <a href="https://github.com/Faizullah9181/Ecommerce-Django-React">   <li >View Github</li> </a> 
         


          </ul>
          

        </SwiperSlide>

        <SwiperSlide>
          <img src={MusicApp} alt="musicapp" />

          <ul className="p"  style={{ listStyleType: "none" }}>
         
         <a href="https://github.com/Faizullah9181/Music-App">   <li >View Github</li> </a> 


          </ul>
        </SwiperSlide>

        <SwiperSlide>
      
            
            <img src={RealEstate} alt="realestate" />
            
             
     
            <ul className="p"  style={{ listStyleType: "none" }}>
            <a href="https://nexus-global.herokuapp.com/">   <li >View Link</li> </a> 
            <a href="https://github.com/Faizullah9181/Real-Estate-DBMS-PROJECT">   <li >View Github</li> </a> 


          </ul>
        </SwiperSlide>

        <SwiperSlide>
          <img src={BookStore} alt="bookstore" />

          <ul className="p"  style={{ listStyleType: "none" }}>
          <a href="https://web3bookstorefaiz.netlify.app/">   <li >View Link</li> </a> 
         <a href="https://github.com/Faizullah9181/Web3-Book-Store">   <li >View Github</li> </a> 


          </ul>
        </SwiperSlide>

        <SwiperSlide>
          <img src={EDA} alt="fifaeda" />

          <ul className="p"  style={{ listStyleType: "none" }}>
          
         <a href="https://github.com/Faizullah9181/Data-Science/blob/main/EDA/Fifa_EDA/Fifa_EDA.ipynb">   <li >View Github</li> </a> 


          </ul>
      </SwiperSlide>

        <SwiperSlide>
          <img src={Birds} alt="birds" />

          <ul className="p"  style={{ listStyleType: "none" }}>

         <a href="https://github.com/Faizullah9181/Data-Science/blob/main/Projects/Bird_Species_Prediction/Bird_Species_Prediction.ipynb">   <li >View Github</li> </a> 


          </ul>


        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Portfolio;
